module.exports = __webpack_public_path__ + "static/media/madewithmoises.889b1305.svg";